import { useMemo } from 'react';
import { isAfter } from 'date-fns';
import { useRecoilValue } from 'recoil';
import { HOURS_PER_DAY, SECOND } from 'time-constants';

import { dayDateTimeState, hourlyForecastState } from '@store';

import { TimeUtils } from '../helpers/TimeUtils';

export const useMyWeatherHourlyForecast = (observingDateUtc, hours = 7 * HOURS_PER_DAY) => {
  const { data } = useRecoilValue(hourlyForecastState);
  const { timeZone: locationTimezone } = useRecoilValue(dayDateTimeState);
  let from = 0;
  /**
   * if observing date is undefined or today or any previous day, then slice 168 hours from 0
   * else slice 168 hours from the 12am of observing date
   */

  if (observingDateUtc) {
    const observingDateMilliseconds = observingDateUtc * SECOND;

    if (
      isAfter(observingDateMilliseconds, new Date()) &&
      !TimeUtils.isZonedToday(observingDateMilliseconds, locationTimezone)
    ) {
      const observingDate = TimeUtils.zonedStartOfDay(TimeUtils.dateFromEpoch(observingDateUtc), locationTimezone);
      const startOfNextHourUtc = observingDate.getTime() / SECOND;

      from = data?.validTimeUtc?.indexOf(startOfNextHourUtc) ?? 0;
    }
  }
  return useMemo(() => (data ? sliceHourlyForecast(data, from, hours) : []), [data, from, hours]);
};

const sliceHourlyForecast = (data, from, length) =>
  Array.from({ length }, (_, index) => {
    const pos = from + index;

    return {
      dayOfWeek: data?.dayOfWeek?.[pos],
      iconCodeExtend: data?.iconCodeExtend?.[pos],
      temperature: data?.temperature?.[pos],
      precipChance: data?.precipChance?.[pos],
      validTimeUtc: data?.validTimeUtc?.[pos],
      qpf: data?.qpf?.[pos],
      relativeHumidity: data?.relativeHumidity?.[pos],
      temperatureDewPoint: data?.temperatureDewPoint?.[pos],
      temperatureFeelsLike: data?.temperatureFeelsLike?.[pos],
      uvIndex: data?.uvIndex?.[pos],
      visibility: data?.visibility?.[pos],
      windDirectionCardinal: data?.windDirectionCardinal?.[pos],
      windGust: data?.windGust?.[pos],
      windSpeed: data?.windSpeed?.[pos],
    };
  });
